var render = function (_h,_vm) {var _c=_vm._c;return (_vm.props.isOpen)?_c('portal',{attrs:{"to":"slidePanel"}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }